import { ActorRefFrom, createMachine, InterpreterFrom, StateMachine, StateValueFrom } from "xstate"

import { Ev } from "../../../_common/machines/event"

type SubmitStatusContext = unknown
type Typestates = { value: "idle" | "step1" | "step2" | "step3" | "step4" | "overtime"; context: SubmitStatusContext }
export type SubmitStatusEvents = Ev<"START"> | Ev<"RESET"> | Ev<"COMPLETE">

export const submitStatusMachine = createMachine<SubmitStatusContext, SubmitStatusEvents, Typestates>({
    id: "submit-status",
    initial: "idle",
    predictableActionArguments: true,
    context: {},
    states: {
        idle: {
            on: {
                START: { target: "step1" },
            },
        },
        step1: {
            after: {
                5000: { target: "step2" },
            },
        },
        step2: {
            after: {
                5000: { target: "step3" },
            },
        },
        step3: {
            after: {
                6000: { target: "step4" },
            },
        },
        step4: {
            after: {
                12000: { target: "overtime" },
            },
        },
        overtime: {},
    },
    on: {
        RESET: { target: "idle" },
        COMPLETE: { target: "idle" },
    },
})

export type SubmitStatusMachine = StateMachine<
    SubmitStatusContext,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any,
    SubmitStatusEvents,
    Typestates
>
export type SubmitStatusActor = ActorRefFrom<SubmitStatusMachine>
export type SubmitStatusService = InterpreterFrom<SubmitStatusMachine>
export type SubmitStatusState = SubmitStatusService["state"]
export type SubmitStatusSend = SubmitStatusService["send"]
export type SubmitStatusStateValue = StateValueFrom<SubmitStatusMachine>

export const submitStatusValue = (state: SubmitStatusState): SubmitStatusStateValue => {
    return state.value as SubmitStatusStateValue
}
